import {MatPasswordStrengthComponent} from '@angular-material-extensions/password-strength';
import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerPortalService } from 'src/app/features/retailer-portal/retailer-portal.service';
import { LoginService } from 'src/app/layout/services/login.service';
import { ProfileService } from '../../profile.service';

@Component({
  selector: "app-password-update",
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.scss'],
})
export class PasswordUpdateComponent extends FeaturesBaseComponent implements OnInit{
  @ViewChild('passwordComponentWithConfirmation', {static: true})
  passwordComponentWithConfirmation: MatPasswordStrengthComponent;
  showVerifyCode: boolean = true;
  otp: number  // it can be type string if you don't set allowNumbersOnly to true
  username: string;
  config = {
    allowNumbersOnly: true, // this is false by default
    setTypePassword: false, // this is false by default
    length: 4, // the default is 4
    inputStyles: {
      width: '60px',
      height: '60px',
      border: '2px solid rgb(15, 34, 69)',
      'border-radius': '10px',
      'font-weight': 'bolder',
      color: 'rgb(15, 34, 69)',
    },
  };
  canSubmit: boolean = false;
  notification: any;
  notificationMethod: string;
  showResetPassword: boolean;
  resetForm: FormGroup;
  password: string;
  showDetails: boolean = false;
  color = '';


  userName: any;
  user_id: any;

  constructor(private profileService:ProfileService,private retailerPortalService: RetailerPortalService, private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<PasswordUpdateComponent>,
    private formBuilder: FormBuilder, private loginService: LoginService
  ) {
    super();
      if(data && data){
        if (data.cntx == 'resetPrompt'){
          this.userName = data.userName;
          this.user_id = data.user_id;
          this.showResetPassword = true;
          this.showVerifyCode = !this.showResetPassword;
          // this.verifyResetPassword()
        }
      }
  }








  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  verifyResetPassword(){
    //call API to send verify code
    this.showVerifyCode = true;
    this.showResetPassword = !this.showVerifyCode;
  }

  onOtpChange(e) {
    if (e.length >= 4) {
      this.otp = e;
      this.canSubmit = true;
    }
    else {
      this.canSubmit = false;
    }
  }

  submit() {
    if (this.user_id && this.otp) {
      this.verifyCode()
    }
  }
  verifyCode() {
    this.profileService.verify(this.otp, this.user_id).subscribe(res => {
      if (res.httpcode == 200) {
        this.showResetPassword = true;
        this.showVerifyCode = !this.showResetPassword;     
      }
    });
  }
  
  onReSenedCode() {
    let _userverify = JSON.parse(localStorage.getItem('userVerify'));
    
    this.notificationMethod = _userverify.notification == 'sms' ? "mobile number" : "email"
    this.profileService.getVerifyOtp(this.user_id, this.notificationMethod).subscribe((res)=>{
      if(res['httpcode'] == 200 ){
        this.toastrService.success('Re-Generated OTP', 'Success', { timeOut: 1500 })
        
      }})
  }

  
  ngOnInit():void{
    super.ngOnInit()

  }


  ngOnDestroy():void{
    super.ngOnDestroy()
  }
  closeResetPassword(e){
    this.onConfirmClick()
  }
}
